import { GUIDES } from '../content/guides';

export interface NavFeatureItem {
  label: string;
  href: string;
  description: string;
}

/** A feature group: `group` labels it in menus, `headline` and `summary` on the features page. */
export interface NavFeatureGroup {
  group: string;
  headline: string;
  summary: string;
  items: NavFeatureItem[];
}

export interface NavLink {
  label: string;
  href: string;
  featureGroups?: NavFeatureGroup[];
}

export const STANDOUT_FEATURES: NavFeatureGroup = {
  group: 'Stand out',
  headline: 'What sets Resida apart',
  summary:
    'Most landlord apps stop at storing records. These do the work: they match Zelle rent, run leasing and repairs with AI assistants, file receipts you forward by email, and answer your questions in Claude or ChatGPT.',
  items: [
    {
      label: 'Rent Tracking with Zelle',
      href: '/features/rent-collection',
      description: 'Zelle and Venmo rent matched to the right lease',
    },
    {
      label: 'Leasing & Listings',
      href: '/features/leasing',
      description: 'Craigslist and Facebook posting, lead pipeline, AI assistant',
    },
    {
      label: 'Maintenance & Repairs',
      href: '/features/maintenance',
      description: 'Repair requests coordinated by an AI assistant',
    },
    {
      label: 'Expense Tracking by Email',
      href: '/features/expense-tracking',
      description: 'Forward receipts; AI files them under the right unit',
    },
    {
      label: 'Claude & ChatGPT',
      href: '/features/ai-assistants',
      description: 'Ask your AI assistant about your rentals'
    },
  ],
};

export const ESSENTIAL_FEATURES: NavFeatureGroup = {
  group: 'Essentials',
  headline: 'Everything else you expect',
  summary:
    'The everyday tools every landlord needs, all working from the same records, so nothing has to be entered twice.',
  items: [
    {
      label: 'Attention Dashboard',
      href: '/features/dashboard',
      description: 'Everything that needs you, sorted by urgency',
    },
    {
      label: 'Lease Management',
      href: '/features/lease-management',
      description: 'Guided leases with clause and disclosure reminders',
    },
    {
      label: 'Walkthroughs',
      href: '/features/walkthroughs',
      description: 'Move-in and move-out checklists with photos',
    },
    {
      label: 'Document Signing',
      href: '/features/document-signing',
      description: 'Built-in e-signatures at no extra cost',
    },
    {
      label: 'Tenant Communication',
      href: '/features/tenant-communication',
      description: 'In-app chat and email in one inbox',
    },
  ],
};

export const FEATURE_GROUPS: NavFeatureGroup[] = [STANDOUT_FEATURES, ESSENTIAL_FEATURES];

// Mirrors routes.tsx: the guides section only exists once there is at least one guide.
const GUIDES_LINK: NavLink[] = GUIDES.length > 0 ? [{ label: 'Guides', href: '/guides' }] : [];

export const NAV_LINKS: NavLink[] = [
  {
    label: 'Features',
    href: '/features',
    featureGroups: FEATURE_GROUPS,
  },
  ...GUIDES_LINK,
  { label: 'Pricing', href: '/pricing' },
  { label: 'Contact', href: '/contact' },
];

export const FOOTER_LINKS = {
  features: FEATURE_GROUPS,
  company: [
    ...GUIDES_LINK,
    { label: 'Pricing', href: '/pricing' },
    { label: 'Contact', href: '/contact' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Terms of Service', href: '/terms-of-service' },
  ],
};
